import { CalendarAppointmentStatus } from '../../constants/calendar'

import {
  APPOINTMENT_REMINDER_NONE,
  AppointmentFollowUpAction,
  AppointmentParticipantKind,
  APPOINTMENTS_LOADING_STATE,
} from './Appointment.constants'

export function getIsAppointmentCancelled(status) {
  return status === CalendarAppointmentStatus.cancelled
}

export function getIsAppointmentExternalParticipant(participant) {
  return participant.kind === AppointmentParticipantKind.external
}

export function getIsAppointmentFollowUpApply(action) {
  return action === AppointmentFollowUpAction.apply
}

export function getIsAppointmentReminderNone(minutes) {
  return minutes === APPOINTMENT_REMINDER_NONE
}

export function getAppointmentsRequestKey(params) {
  return JSON.stringify(params, Object.keys(params).sort())
}

export function getAppointmentsState({ requestKey, response }) {
  return response.requestKey === requestKey
    ? response
    : APPOINTMENTS_LOADING_STATE
}
